const CDN_BASE = "https://images.clickforcode.workers.dev";

const PEOPLE_FOLDER = "people-webp";
const PROJECT_FOLDER = "project-images-webp";
const LOGOS_FOLDER = "logos-webp";

export function getStaticURL(key) {
  const cleaned = String(key || "").replace(/^\/+/, "");
  return `${CDN_BASE}/${cleaned}`;
}

function stemToWebp(stem) {
  return String(stem || "").replace(/\.(jpe?g|png|webp)$/i, "");
}

/** Get URL from basename - eg: peopleImage("credit-culture__vaibhav") */
export function peopleImage(stem) {
  return getStaticURL(`${PEOPLE_FOLDER}/${stemToWebp(stem)}.webp`);
}

/** Project/case-study image URL - eg: projectImage("jiffy-brand-hero") */
export function projectImage(stem) {
  return getStaticURL(`${PROJECT_FOLDER}/${stemToWebp(stem)}.webp`);
}

/** Logo URL - eg: logoImage("ShakesPeers") */
export function logoImage(stem) {
  return getStaticURL(`${LOGOS_FOLDER}/${stemToWebp(stem)}.webp`);
}
